import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TJobsResponsePayload, TClassificationsStore, TJobsRequest } from './types';

export const initialState: TClassificationsStore = {
	jobs: null,
	jobsLoading: false,
	jobsError: null,
};

const classifications = createSlice({
	name: '@@classifications',
	initialState,
	reducers: {
		getJobsRequest: (state: TClassificationsStore) => {
			const jobsState = state;
			jobsState.jobsLoading = true;
		},
		getJobsSuccess: (state: TClassificationsStore, action: PayloadAction<TJobsResponsePayload>) => {
			const jobsState = state;
			jobsState.jobs = action.payload;
			jobsState.jobsLoading = false;
		},
		getJobsFailure: (state: TClassificationsStore) => {
			const jobsState = state;
			jobsState.jobsLoading = false;
		},
		classificationsInitState: () => initialState,
	},
});

export const { getJobsRequest, getJobsSuccess, getJobsFailure } = classifications.actions;

export default classifications.reducer;
